<template>
  <div class="dialog-upload-thesis" style="background-color:#fff;padding:20px;margin:10px;border-radius:4px">
    <Row class="g-ml">
      <Col span="6">
        送审年份：{{schoolYear}}
      </Col>
      <Col span="6">
        送审季度：{{schoolSeason}}
      </Col>
      <Col span="6">
        关联批次：
        <Select style="width:200px" v-model="batchId">
          <Option v-for="(item, index) in batchList" :key="index" :value="item.id">{{item.name}}</Option>
          <!-- <Option v-for="item in cityList" :value="item.value" :key="item.value">1</Option> -->
        </Select>
      </Col>
      <Col span="24">
        如需更改送审年份及送审季度，请到送审季度设置中进行更改。
        <!-- <a href="http://www.baidu.com">单击此处跳转？</a> -->
      </Col>
    </Row>
    <Form :label-width="140" class="btnnextF">
      <FormItem  label="汇总数据上传表：" class="summary">
        <element-upload url="/paper/paperBaseInfo/upload"
                        :format="['xlsx']"
                        :data={sendType:this.defaultQuery.sendType,batchId:this.batchId}
                        @on-success="handleSuccess"
        ></element-upload>
      </FormItem>
      <div class="g-ml">
        <span style="font-weight:600">温馨提示：</span>
        <p style="color: red">1、上传原文，摘要，简况表，自评表前，请确认汇总表内已有对应数据</p>
        <p>2、文件命名规则：KFPY_学校代码_HZSJB.xlsx，例如：KFPY_10001_HZSJB.xlsx；</p>
        <p>3、<a href="/static/demo/KFPY_10001_HZSJB.xlsx">点此下载汇总数据表模板</a></p>
      </div>
    </Form>
    <Form :label-width="140" class="btnnextF">
      <FormItem  label="论文原文上传：" class="originPaper">
        <element-upload url="/paper/fileOriginalInfo/uploadFile"
                        :format="['zip']"
                        :data="{batchId:this.batchId,uploadType:'LW'}"
                        @on-success="handleSuccess"
        ></element-upload>
      </FormItem>
      <div class="g-ml">
        <span style="font-weight:600">温馨提示：</span>
        <p>1、压缩包命名规则：KEPY_学校代码_LW</p>
        <p>2、文件命名规则：学号.pdf 如果有双学位学号，命名规则为 学号_专业.pdf</p>
        <p>3、选中所有文件直接压缩，不要把文件放到文件夹中压缩文件夹，否则无法成功上传</p>
      </div>
    </Form>
    <Form :label-width="140" class="btnnextF">
      <FormItem  label="论文摘要上传：" class="summary" style="margin-left:-19px">
        <element-upload url="/paper/fileOriginalInfo/uploadFile"
                        :format="['zip']"
                        :data="{batchId:this.batchId,uploadType:'ZY'}"
                        @on-success="handleSuccess"
        ></element-upload>
      </FormItem>
      <div class="g-ml">
        <span style="font-weight:600">温馨提示：</span>
        <p>1、压缩包命名规则：KEPY_学校代码_ZY</p>
        <p>2、文件命名规则：学号.pdf 如果有双学位学号，命名规则为 学号_专业.pdf</p>
        <p>3、选中所有文件直接压缩，不要把文件放到文件夹中压缩文件夹，否则无法成功上传</p>
      </div>
    </Form>
    <Form :label-width="140" class="btnnextF">
      <FormItem  label="论文简况表上传：" class="summary">
        <element-upload url="/paper/fileOriginalInfo/uploadFile"
                        :format="['zip']"
                        :data="{batchId:this.batchId,uploadType:'JKB'}"
                        @on-success="handleSuccess"
        ></element-upload>
      </FormItem>
      <div class="g-ml">
        <span style="font-weight:600">温馨提示：</span>
        <p>1、压缩包命名规则：KEPY_学校代码_JKB</p>
        <p>2、文件命名规则：学号.pdf 如果有双学位学号，命名规则为 学号_专业.pdf</p>
        <p>3、选中所有文件直接压缩，不要把文件放到文件夹中压缩文件夹，否则无法成功上传</p>
      </div>
    </Form>
    <Form :label-width="140" class="btnnextF">
      <FormItem  label="论文自评表上传：" class="summary">
        <element-upload url="/paper/fileOriginalInfo/uploadFile"
                        :format="['zip']"
                        :data="{batchId:this.batchId,uploadType:'ZPB'}"
                        @on-success="handleSuccess"
        ></element-upload>
      </FormItem>
      <div class="g-ml">
        <span style="font-weight:600">温馨提示：</span>
        <p>1、压缩包命名规则：KEPY_学校代码_ZPB</p>
        <p>2、文件命名规则：学号.pdf 如果有双学位学号，命名规则为 学号_专业.pdf</p>
        <p>3、选中所有文件直接压缩，不要把文件放到文件夹中压缩文件夹，否则无法成功上传</p>
      </div>
    </Form>
  </div>
</template>

<script>
import ElementUpload from '@/components/elements/upload'

export default {
  name: 'uploadThesis',
  components: {ElementUpload},
  props: {
    defaultQuery: ''
  },
  data () {
    return {
      activeclass: 0,
      statusText1: {
        success: '上传成功',
        error: '上传失败',
        uploading: '上传中',
        paused: '暂停中',
        waiting: '等待中'
      },
      batchId: '',
      schoolYear: '',
      schoolSeason: '',
      batchList: [],
      options1: {
        target: '/dup/file/fileUpload',
        chunkSize: 5 * 1024 * 1024,
        testChunks: false,
        query: {batchId: this.batchId},
        headers: {
          token: this.$store.state.user.token
        }
      }
    }
  },
  created () {
    this.fetchDetail()
    this.getCurrentSeasonBatchListBySendType()
  },
  watch: {
    $route (to) {
      if (to.path === '/shell/allAuthorize/custom/thesisManage/uploadThesis' || to.path === '/shell/allSelf/custom/thesisManage/uploadThesis') {
        this.fetchDetail()
        this.getCurrentSeasonBatchListBySendType()
      }
    }
  },
  // watch: {
  //   '$route' (to) {
  //     if (to.name === 'uploadThesis') {
  //       this.getCurrentSeasonBatchListBySendType()
  //       console.log('111')
  //     }
  //   }
  // },
  methods: {
    test () {
      console.log(this.batchId)
    },
    getCurrentSeasonBatchListBySendType () {
      let searchParam = new URLSearchParams();
      searchParam.append('sendType', this.defaultQuery.sendType);
      this.post(`/school/schoolBatch/getCurrentSeasonBatchListBySendType`, searchParam)
        .then((res) => {
          this.batchList = res.data
          this.batchId = this.batchList[0].id
        })
        .catch((error) => {
          console.log(error)
        });
    },
    fetchDetail () {
      this.post(`/school/schoolQuarter/getCurrentSchoolSeason`)
        .then((res) => {
          this.schoolYear = res.data.auditYear
          this.schoolSeason = res.data.seasonName
        })
        .catch((error) => {
          console.log(error)
        });
    },
    te () {
      console.log(this.batchId)
    },
    winclose () {
      this.$emit('reload')
    },
    Gonext () {
      this.activeclass++
    },
    handleSuccess () {
      this.$emit('fetchTableList')
    },
    onFileAdded (file) {
      // 添加时间戳
      this.options1.query.timestamp = new Date().getTime();
      this.post('/paper/fileOriginalInfo/checkFileName/' + file.name).then(res => {
      }).catch(() => {
        file.cancel();
      });
    }
  }
}
</script>

<style lang="less" scoped>
  .dialog-upload-thesis {
    height: 100%;
    overflow: auto;
    padding-left: 37px;
    .tabbarbox{
      height: 30px;
      width: 20px;
      margin-left: 5.5px;
      border-left: 1px solid rgba(00,00,00,0.09);
    }
    .twostyle1{
      height: 30px;
      width: 100px;
      position: relative;
    }
    .twostyle2{
      border-style: none;
      position: absolute;
      top: 2px;
    }
    .btnnextF{
      position: relative;
      margin-top: 30px;
      // flex: 1;
    }
    .btnnext{
      text-align: center;
      line-height: 30px;
      position: absolute;
      bottom: 1px;
      left: 180px;
      width: 60px;
      height: 30px;
      border-radius: 5px;
      background-color: #3bafda;
      color: #ffffff;
      cursor:pointer;
    }
    .tab-bar{
      list-style: none;
    }
    .tab-bar li{
      cursor:pointer;
      width: 84px;
      font-size: 13px;
      height: 13px;
      line-height: 13px;
      text-align: left;
    }
    .tab-bar li.active{
      width: 84px;
      color: #3bafda;
    }
    .originPaper{
      margin-top: 10px;
      margin-left: -19px;
    }
    /deep/.originPaper,summary{
      .kh-form-item-label::before{
        content: '*';
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-size: 12px;
        color: #ff7372;
      }
    }
    /deep/.summary{
      margin-left: -7px;
      margin-top: 10px;
      width: 490px;
      .kh-form-item-label::before{
        content: '*';
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-size: 12px;
        color: #ff7372;
      }
    }
    /deep/.uploader-list {
      position: absolute;
      left: -80px;
      right: 0;
      top: 35px;
      .uploader-file {
        width: 100%;
      }
    }
  }
</style>
<style lang="less">
  .dialog-upload-thesis .kh-form-item-label {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/layout/customPage/thesisManage/uploadThesis.vue